<template>
  <div>
    <a v-if="!automatic" href="javascript:void(0)" @click="stripeModal" class="text-base text-logo-dark hover:text-gray-800 hover:underline">
      Manage Payment Method <small class="font-normal"><i>(Current Card: {{last4 || 'No Card On File'}})</i></small>
    </a>
    <div v-show="showForm"
      class="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full flex items-center justify-center">
      <div class="relative bg-white rounded-lg shadow-xl p-8 max-w-md w-full">
        <div class="mb-4">
          <div class="flex justify-between">
            <h3 class="text-lg font-medium text-gray-900">Payment Information</h3>
            <a :href="`${stripeConfigs.link}`"
              target="_blank"
            rel="noopener noreferrer"
              class="hover:opacity-80 transition-opacity">
              <img src="/images/logos/Powered by Stripe - blurple.svg" class="h-6" />
            </a>
          </div>
          <ul class="list-disc list-inside">
            <li class="text-gray-600 text-sm">You will not be charged until you submit an order</li>
            <li class="text-gray-600 text-sm">Holds are placed on your card when you submit an order</li>
            <li class="text-gray-600 text-sm">The charge is not completed until the order is completed</li>
          </ul>
        </div>
        <form @submit.prevent="handleSubmit" class="space-y-4">
          <div id="card-element" class="p-4 border rounded"></div>
          <div v-if="error" class="text-red-500 text-sm mt-2">{{ error }}</div>
          <div class="flex justify-between">
            <!-- <button type="submit"
              class="inline-flex items-center px-4 py-2 bg-gray-800 border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest hover:bg-gray-700 focus:bg-gray-700 active:bg-gray-900 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 transition ease-in-out duration-150">
              Save Credit Card
            </button> -->
            <button type="submit"
              class="btn btn-logo w-[250px]"
              :disabled="isLoading">
              <div v-if="!isLoading">Save Credit Card</div>
              <div class="flex items-center" v-else>
                <svg class="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                  <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                Saving...
              </div>
            </button>
            <button type="button" @click="showForm = false"
              class="link link-red">
              Cancel
            </button>
          </div>
        </form>
      </div>

    </div>
  </div>
</template>

<script>
import StoreCard from './StoreCard.vue';

export default {
  props: ['agency', 'stripeConfigs', 'automaticTrigger', 'refresh'],
  components: {
    StoreCard: StoreCard
  },
  data() {
    return {
      stripeForm: {
        stripeToken: '',
      },
      stripe: null,
      isLoading: false,
      error: null,
      card: null,
      stripeClientSecret: this.stripeConfigs.clientSecret,
      stripePublishableKey: this.stripeConfigs.stripePublishableKey,
      last4: this.stripeConfigs.last4,
      automatic: this.automaticTrigger || false,
      showForm: false
    };
  },
  mounted() {
    if (this.automaticTrigger) {
      this.stripeModal();
    }
  },
  methods: {
    stripeModal() {
      this.showForm = true;
      this.error = null;
      this.isLoading = false;
      this.stripe = Stripe(this.stripePublishableKey);
      const appearance = { /* appearance */ };
      const options = { layout: 'accordion', /* options */ };
      const elements = this.stripe.elements({ clientSecret: this.stripeClientSecret, appearance });
      // this.card = elements.create('card', options);
      this.card = elements.create('card');
      this.card.mount('#card-element');
    },
    async handleSubmit() {
      this.isLoading = true;
      const { error: stripeError, paymentMethod } = await this.stripe.createPaymentMethod({
        type: 'card',
        card: this.card,
      });

      if (stripeError) {
        this.error = stripeError.message;
      } else {
        this.stripeForm.stripeToken = paymentMethod.id;
        await axios.patch('/agencies/' + this.agency.id + '/store_card', this.$data.stripeForm)
          .then(({ data }) => {
            this.$toast.success(data.message);
            this.last4 = data.last4;
            this.showForm = false;
            if (this.refresh) {
              window.location.reload();
            }
          }).catch((errors) => {
            if (errors.response.data.stripe_error) {
              this.error = errors.response.data.stripe_error;
            }
            // flash(errors.response.data.error);
            this.$toast.error(errors.response.data.error);
          });
      }
      this.isLoading = false;
    }
  }
}
</script>